var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"badge mr-5",style:(_vm.tagStyleObj)},[_c('i',{staticClass:"icon-lineIcon-master"}),_c('span',{staticStyle:{"color":"#222222","vertical-align":"middle"}},[_vm._v(_vm._s(_vm.statusStr))])])
}
var staticRenderFns = []

export { render, staticRenderFns }